import React, { Component } from 'react';

import { Routing } from 'configs';
import Settings from 'configs/Settings';
import { isRenderInIframe } from 'helpers/Location';
import { injectNewRelic } from 'helpers/Settings';
import { FeatureToggleService, FeatureToggles } from 'modules/featureToggle';
import { getSubdomainByUrl } from 'modules/membership/helpers';

import AppWrapper from './AppWrapper';

class App extends Component {
  constructor(props) {
    super(props);

    this.subdomain = getSubdomainByUrl();
  }

  get shouldInjectNewRelic() {
    const isFeatureToggleNewRelicEnabled = FeatureToggleService.isEnabled(
      FeatureToggles.NewRelic
    );

    return isFeatureToggleNewRelicEnabled && !window.Cypress;
  }

  componentDidMount() {
    if (this.shouldInjectNewRelic) {
      injectNewRelic();
    }

    if (isRenderInIframe()) {
      window.addEventListener('click', this.handleBodyClickInBw);
    }
  }

  componentWillUnmount() {
    if (isRenderInIframe()) {
      window.removeEventListener('click', this.handleBodyClickInBw);
    }
  }

  handleBodyClickInBw() {
    const BUSINESS_WORKSPACE_WINDOW_CLICK_EVENT_TYPE = 'WINDOW_CLICK_LISTENER';

    window.parent.postMessage(
      { type: BUSINESS_WORKSPACE_WINDOW_CLICK_EVENT_TYPE },
      Settings.app.bw
    );
  }

  render() {
    return (
      <AppWrapper subdomain={this.subdomain}>
        <Routing />
      </AppWrapper>
    );
  }
}

export default App;
